import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { SearchableSelect } from '../_shared/forms/FormMultiSelect';
import FormInputNumber from '../_shared/forms/FormInputNumber';

class JobSources extends Component {
    constructor(props) {
        super(props);

        let { job_source } = this.props;
        const job_types = [...this.props.job_types];
        let field_groups = [];

        if (job_source && job_source.job_types) {
            job_source.job_types.map((el, i) => {
                field_groups.push({ key: i, id: el.id, default_cy: el.pivot.default_cy });
                //Make preselected job types disabled
                job_types.find((e) => e.id == el.id).disabled = 'yes';
            });
        }
        this.state = {
            field_groups: field_groups.length > 0 ? field_groups : [{ key: 1, id: '', default_cy: '' }],
            job_types: job_types,
            field_group_delete_errors: '',
            errors: {},
        };
    }

    handleChange = (e, i) => {
        let field_groups = [...this.state.field_groups];
        let field_group = { ...field_groups[i] };
        field_group.default_cy = e.target.value;
        field_groups[i] = field_group;
        this.setState({
            field_groups: field_groups,
        });
    };

    handleSelectChange = (e, i) => {
        let field_groups = [...this.state.field_groups];
        let job_types = [...this.state.job_types];
        let field_group = { ...field_groups[i] };

        //If option was previously selected make it clickable again
        if (field_group.id) {
            let previously_selected_job_type = job_types.findIndex((el) => el.id == field_group.id);
            job_types[previously_selected_job_type].disabled = '';
        }
        //Add selected value
        field_groups[i] = { ...field_group, id: e.value };

        //Make selected option disabled
        let selected_job_index = job_types.findIndex((el) => el.id == e.value);
        job_types[selected_job_index].disabled = 'yes';

        this.setState({
            field_groups: field_groups,
            job_types: job_types,
        });
    };

    appendFieldGroup = (e) => {
        e.preventDefault();
        let field_groups = [...this.state.field_groups];
        let lastFieldId = field_groups[field_groups.length - 1].key + 1;

        field_groups.push({ key: lastFieldId, id: '', default_cy: '' });

        this.setState({
            field_groups: field_groups,
            field_group_delete_errors: '',
        });
    };

    removeFieldGroup = (e, i) => {
        e.preventDefault();
        let field_groups = [...this.state.field_groups];
        let job_types = [...this.state.job_types];

        if (field_groups.length === 1) {
            return this.setState({
                field_group_delete_errors: 'You need at least one job type',
            });
        }

        //If the field group had selected option, make it clickable again
        let field_group = field_groups.splice(i, 1)[0];
        let selected_index = job_types.findIndex((el) => el.id == field_group.id);
        if (job_types[selected_index]) {
            job_types[selected_index].disabled = '';
        }

        window.swal
            .fire({
                title: `Delete this field group?`,
                text: `Are you sure you want to delete this field group?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;
                this.setState({
                    field_groups: field_groups,
                    job_types: job_types,
                });
            });
    };

    render() {
        let { job_types, field_groups, field_group_delete_errors } = this.state;

        return (
            <div>
                {field_groups.map((field_group, i) => {
                    return (
                        <div className="row" key={field_group.key}>
                            <div className="col-md-5 form-group">
                                <SearchableSelect
                                    classes="job_source_select"
                                    isSearchable={true}
                                    name="job_types[]"
                                    options={job_types}
                                    handleChange={(e) => this.handleSelectChange(e, i)}
                                    label="Job Type"
                                    value={field_group}
                                />
                                {field_group_delete_errors && (
                                    <small className="text-danger">{field_group_delete_errors}</small>
                                )}
                            </div>
                            <div className="col-md-5 form-group">
                                <FormInputNumber
                                    name="default_cy[]"
                                    type="number"
                                    classes="form-control required"
                                    handleChange={(e) => this.handleChange(e, i)}
                                    label="Default CY"
                                    step={1}
                                    min={1}
                                    value={field_group.default_cy || ''}
                                />
                            </div>
                            <div className="form-group col-md-2 text-center">
                                <label>&nbsp;</label>
                                <div onClick={(e) => this.removeFieldGroup(e, i)}>
                                    <i className="nc-icon nc-simple-remove icon-bold text-danger pb-3"> </i>
                                </div>
                            </div>
                        </div>
                    );
                })}
                <div className="row">
                    <div className="col-md-12">
                        <button type="button" className="btn btn-cw-primary" onClick={(e) => this.appendFieldGroup(e)}>
                            Add another job source
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('job_source_fields')) {
    const fields = document.getElementById('job_source_fields');
    ReactDOM.render(
        <JobSources
            job_types={JSON.parse(fields.dataset.job_types)}
            job_source={JSON.parse(fields.dataset.job_source)}
        />,
        fields
    );
}
